// extracted by mini-css-extract-plugin
export default {"Card":"LoginPage_Card__id-uS"};